'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _doctify = require('../../src/assets/doctify.svg');

var _doctify2 = _interopRequireDefault(_doctify);

var _availabilityCalendar = require('availability-calendar');

var _dropdown = require('dropdown');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _widgetActions = require('../actions/widget-actions');

var _constants = require('../utils/constants');

var _utils = require('../utils/utils');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;

try {
  messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
  messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var onOpenSpecialistProfile = function onOpenSpecialistProfile(props) {
  if (props.widget.specialist.specialist && props.widget.specialist.specialist.uri_id) {
    window.open('https://www.doctify.co.uk/specialist/' + props.widget.specialist.specialist.uri_id, '_blank');
  }
};

var _ref2 = _react2.default.createElement(
  'a',
  {
    href: 'https://www.doctify.co.uk',
    target: '_blank',
    rel: 'nofollow noopener'
  },
  _react2.default.createElement('img', { src: _doctify2.default })
);

var BookingWidget = function BookingWidget(props) {
  return props.widget && props.widget.specialist && props.widget.specialist.practices && props.widget.specialist.practices.length > 0 && _react2.default.createElement(
    _reactIntl.IntlProvider,
    { locale: localeBase, messages: messages },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: _style2.default.header },
        _react2.default.createElement(
          'div',
          { className: _style2.default.titleContainer },
          _react2.default.createElement(
            'span',
            { className: _style2.default.title },
            'Book an appointment'
          ),
          props.widget.specialist.specialist && props.widget.specialist.specialist.name && _react2.default.createElement(
            'div',
            { className: _style2.default.subtitle },
            'with ',
            props.widget.specialist.specialist.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default.dropdownContainer },
          _react2.default.createElement(_dropdown.Dropdown, {
            id: _style2.default.practiceDropdown,
            items: props.widget.practices,
            readonly: true,
            placeholder: 'Select a practice',
            selectedItem: props.widget.selectedPractice || props.widget.practices && props.widget.practices.length && // TODO why?
            props.widget.practices[0] // TODO why?
            ,
            onItemSelected: function onItemSelected(practice) {
              props.widgetActions.onPracticeSelected(practice);
              props.widgetActions.setNearestAvailability(null);
              props.updateAvailabilities((0, _extends3.default)({}, props.widget, {
                selectedPractice: practice,
                nearestAvailability: null
              }));
            }
          })
        )
      ),
      _react2.default.createElement(_availabilityCalendar.AvailabilityCalendar, {
        startDate: (0, _moment2.default)(props.widget.startDate),
        availabilities: props.widget.availabilities,
        nearestAvailability: props.widget.nearestAvailability,
        hasRequestAppointment: true,
        onPreviousButtonClick: function onPreviousButtonClick() {
          props.updateAvailabilities((0, _extends3.default)({}, props.widget, {
            // Prevents the start date from being set to a day previous to today.
            startDate: _moment2.default.max((0, _moment2.default)(props.widget.startDate).subtract((0, _utils.getVisibleCalendarDays)(), 'd').startOf('day'), (0, _moment2.default)())
          }), true);
        },
        onNextButtonClick: function onNextButtonClick() {
          props.updateAvailabilities((0, _extends3.default)({}, props.widget, {
            startDate: (0, _moment2.default)(props.widget.startDate).add((0, _utils.getVisibleCalendarDays)(), 'd').startOf('day')
          }));
        },
        onSlotClick: function onSlotClick() {
          return onOpenSpecialistProfile(props);
        },
        onRequestAppointmentClick: function onRequestAppointmentClick() {
          return onOpenSpecialistProfile(props);
        },
        onNearestAvailabilityClick: function onNearestAvailabilityClick(date) {
          props.widgetActions.setNearestAvailability(null);
          props.updateAvailabilities((0, _extends3.default)({}, props.widget, {
            startDate: (0, _moment2.default)(date),
            nearestAvailability: null
          }));
        },
        isLoadingAvailabilities: props.widget.isLoading,
        className: _style2.default.calendar }),
      _react2.default.createElement(
        'div',
        { className: _style2.default.logo },
        _ref2
      )
    )
  ) || null;
};

BookingWidget.propTypes = {
  widget: require('react').PropTypes.shape({
    specialist: require('react').PropTypes.object,
    startDate: require('react').PropTypes.object,
    selectedPractice: require('react').PropTypes.object,
    availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.object)
  }).isRequired,
  updateAvailabilities: require('react').PropTypes.func.isRequired
};
BookingWidget.displayName = 'BookingWidget';

BookingWidget.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    global: state.global,
    widget: state.bookingWidget.widget
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    widgetActions: (0, _redux.bindActionCreators)(_widgetActions.widgetActions, dispatch),
    updateAvailabilities: function updateAvailabilities(props, isPreviousDate) {
      var startDate = props && props.startDate;
      dispatch(_widgetActions.widgetActions.updateStartDate(startDate));

      var nearestAvailability = props && props.nearestAvailability;

      // Resets the nearest availability when it is before the current week.
      if (nearestAvailability && (0, _moment2.default)(nearestAvailability).isBefore((0, _moment2.default)(startDate).add(_constants.LAPTOP_CALENDAR_DAYS, 'd'))) {
        dispatch(_widgetActions.widgetActions.setNearestAvailability(nearestAvailability = null));
      }

      // Prevents unnecessary requests from being made when we already know
      // the nearest availability. Availabilities are only updated again:
      //     - When the user is browsing previous dates and the current
      // start date is the same or before the latest availability found.
      //     - If the current start date is the same day or after the previous
      // nearest availability.
      if (!nearestAvailability || isPreviousDate && props && props.latestAvailabilityFound && (0, _moment2.default)(startDate).startOf('day').isSameOrBefore(props.latestAvailabilityFound)) {
        var _specialist = props && props.specialist && props.specialist.specialist && props.specialist.specialist.uri_id;
        var practice = props && props.selectedPractice && props.selectedPractice.id;

        dispatch(_widgetActions.widgetActions.loadAvailabilities(_specialist, {
          startdate: startDate && (0, _moment2.default)(startDate).format('YYYY-MM-DD HH:mm'),
          practice_filter: practice
        })).then(function (response) {
          // Number of days with availabilities.
          var totalDays = response && response.length;

          if (totalDays) {
            dispatch(_widgetActions.widgetActions.setLatestAvailabilityFound((0, _moment2.default)(response[totalDays - 1].start_date)));

            if (nearestAvailability) {
              dispatch(_widgetActions.widgetActions.setNearestAvailability(null));
            }
          } else if (!nearestAvailability) {
            var nearestAvailabilityStartDate = (0, _moment2.default)(startDate).add((0, _utils.getVisibleCalendarDays)(), 'd');
            dispatch(_widgetActions.widgetActions.loadAvailabilities(_specialist, {
              startdate: nearestAvailabilityStartDate.format('YYYY-MM-DD'),
              enddate: nearestAvailabilityStartDate.clone().add(_constants.NEAREST_AVAILABILITY_END_DAYS, 'd').format('YYYY-MM-DD'),
              practice_filter: practice
            })).then(function (availabilities) {
              dispatch(_widgetActions.widgetActions.setNearestAvailability(availabilities && availabilities.length && availabilities[0].start_date || null));
            });
          }
        });
      }
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BookingWidget);